/**
 * Follows `nextCursor` to the last page and returns every item in order. Rejects on any page
 * error (no partial lists) and throws past `maxPages` (a cursor loop is a server bug).
 */
export async function fetchAllPages<T>(
	page: (cursor?: string) => Promise<{ items: T[]; nextCursor?: string | null }>,
	maxPages = 200,
): Promise<T[]> {
	const items: T[] = [];
	let cursor: string | undefined;
	for (let n = 0; n < maxPages; n++) {
		const p = await page(cursor);
		items.push(...p.items);
		if (!p.nextCursor) return items;
		cursor = p.nextCursor;
	}
	throw new Error(`fetchAllPages: more than ${maxPages} pages`);
}
